module.exports = __webpack_public_path__ + "img/defaultPortrait.b4d09ac1.png";